/**
 * Production-portable URL helpers for OPERA OS.
 *
 * Same-origin path deploy (https://cyberwebopera.com/dashboard/dist/):
 *   leave VITE_API_BASE and VITE_PUBLIC_ORIGIN empty — relative /api and /assets work.
 *
 * Subdomain root (https://app.cyberwebopera.com/ → API on apex):
 *   VITE_API_BASE=https://cyberwebopera.com
 *   VITE_PUBLIC_ORIGIN=https://cyberwebopera.com
 *   plus Hostinger OPERA_COOKIE_DOMAIN=.cyberwebopera.com
 *   and OPERA_CORS_ORIGINS=https://app.cyberwebopera.com
 */

function trimSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

export function apiOrigin(): string {
  const raw = String(import.meta.env.VITE_API_BASE ?? "").trim();
  return raw ? trimSlash(raw) : "";
}

export function publicOrigin(): string {
  const raw = String(import.meta.env.VITE_PUBLIC_ORIGIN ?? "").trim();
  if (raw) return trimSlash(raw);
  const api = apiOrigin();
  if (api) return api;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
}

/** Resolve an absolute or root-relative API path for fetch(). */
export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path) || path.startsWith("//")) {
    return path;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const origin = apiOrigin();
  return origin ? `${origin}${normalized}` : normalized;
}

/**
 * Marketing-site / public-website URL (apex), not the OPERA SPA origin.
 * Use for "View website", Work With Us, application form, etc.
 */
export function publicUrl(path = "/"): string {
  if (/^https?:\/\//i.test(path) || path.startsWith("//") || /^(mailto|tel|whatsapp):/i.test(path)) {
    return path;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const origin = publicOrigin();
  return origin ? `${origin}${normalized}` : normalized;
}
